import React from "react"
import styled from "styled-components"
import {
  AGING_COLUMN_OFFSET,
  columnsByComponentSize,
} from "src/frontend/components/Shared/Layout/Components/Statements/AgingReport/AgingColumns"
import { Headers } from "src/frontend/components/Shared/Layout/Components/Statements/shared"
import { useStatementComponentSize } from "src/frontend/components/Shared/Layout/Components/Statements/StatementContext"
import { HeaderStyled } from "src/frontend/components/Shared/Layout/Components/Statements/StatementHeader"

const SpacingDiv = styled.div`
  height: 16px;
`

export const AgingReportStatementHeader: React.FC<{
  ref: React.RefObject<HTMLDivElement | null>
  hide?: boolean
}> = ({ ref, hide }) => {
  const componentSize = useStatementComponentSize()
  const columns = columnsByComponentSize(componentSize)
  if (hide) {
    return <SpacingDiv />
  }
  if (componentSize.isExtraLarge || componentSize.isLarge) {
    return (
      <Headers ref={ref} depth={0}>
        <HeaderStyled
          css={`
            grid-column: span ${AGING_COLUMN_OFFSET};
          `}
        />
        {columns.slice(AGING_COLUMN_OFFSET).map((column) => (
          <HeaderStyled key={column}>{column}</HeaderStyled>
        ))}
      </Headers>
    )
  }
  return null
}
